export default function isOutsideDataCellClick(visualRow: number, visualColumn: number): boolean {
  return visualRow < 0 || visualColumn < 0;
}
